







































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { ILabelValue } from '../../../../interfaces/generic'
import { getTopArtists, getTopGenres, getBpmDistribution, getMostPlayedArtists, getNewestArtists, getTracksImportedTimes } from '@/helpers/features/statistics'
import { LibraryMixin } from '@/mixins'

@Component({
  components: {
    Number: require('./Number').default,
    Top: require('./Top').default,
    PieChart: require('./PieChart').default,
    BarChart: require('./BarChart').default,
    HelpCircle: require('@/components/HelpCircle').default,
    TracksImported: require('./TracksImported').default,
    LibraryBar: require('./LibraryBar').default
  }
})
export default class Statistics extends Mixins(LibraryMixin) {
  topArtists: ILabelValue[] = []
  mostPlayedArtists: ILabelValue[] = []
  newestArtists: ILabelValue[] = []
  topGenres: ILabelValue[] = []
  bpmDistribution: ILabelValue[] = []
  tracksImported: ILabelValue[] = []

  get totalTrackAmount(): number {
    return this.library.tracks.length
  }

  get totalPlaylistAmount(): number {
    return this.$store.getters['library/playlistsFlat'].length
  }

  get numberTracksTitle(): string {
    return this.library.isPartialImport ? 'Tracks*' : 'Tracks'
  }

  @Watch('library', { immediate: true })
  async updateStats() {
    this.topGenres = getTopGenres(this.library.tracks)
    this.bpmDistribution = getBpmDistribution(this.library.tracks)

    // Don't calculate them sync or they all have to wait if one is slow. The above 2 are weird when doing it in nextTick
    this.$nextTick(() => {
      this.topArtists = getTopArtists(this.library.tracks)
    })

    this.$nextTick(() => {
      this.mostPlayedArtists = getMostPlayedArtists(this.library.tracks)
    })

    this.$nextTick(() => {
      this.newestArtists = getNewestArtists(this.library.tracks)

      if (this.$store.state.auth.isDemoUser) {
        this.newestArtists = [
          { label: 'Nero', value: 15 },
          { label: 'Feed Me', value: 14 },
          { label: 'Far Too Loud', value: 14 },
          { label: 'Noisia', value: 12 },
          { label: 'Camo & Krooked', value: 11 },
          { label: 'Sub Focus', value: 8 },
          { label: 'Dimension', value: 8 },
          { label: 'Feint', value: 6 }
        ]
      }
    })

    this.$nextTick(() => {
      this.tracksImported = getTracksImportedTimes(this.library.tracks)

      if (this.$store.state.auth.isDemoUser) {
        this.tracksImported = [
          { label: 'Last 7 days', value: 55 },
          { label: 'Last 30 days', value: 280 },
          { label: 'This year', value: 2177 }
        ]
      }
    })

    // Seems that web worker overhead is larger than running the function.
    // this.topArtists = await SWorker.run(getTopArtists, [this.library.tracks])
    // this.mostPlayedArtists = await SWorker.run(getMostPlayedArtists, [this.library.tracks])
  }
}
